import { createContext } from 'react';

import { ITemplate } from '../../../store/ducks/settings/types';

export interface IPageContext {
  template: ITemplate | undefined;
}

export const PageContext = createContext<IPageContext | null>(null);
